import React, {useEffect, useState} from "react"
import {Button, Checkbox, Form, Input, Modal, Radio, RadioChangeEvent, Row, Select} from "antd"
import Citizen from "./UserTypes/citizen"
import Foreign from "./UserTypes/foreign"
import {useDispatch, useSelector} from "react-redux"
import {config} from "../../Global"
import "antd/lib/checkbox/style/index.css"
import "./style.css"
import {CustomInput} from "../../components/Custom/Input"
import {CustomSelect} from "../../components/Custom/Select"
import {getUserTypes} from "../../store/actions/user";
import {AppStateType} from "../../store";
import apiUser from "../../api/user";
import {useTranslation} from "react-i18next";
import {setFormErrors} from "../../api/types";
import Company from "./UserTypes/company";

const { Option } = Select

const serverUrl =// @ts-ignore
  process.env.NODE_ENV === "development" ? config.SERVER_API_URL : `${ window.location.origin }/api`

type ModalState = {
	open: boolean
	userId: number | null
}

const Register = (props: any) => {
	const dispatch = useDispatch()
	const [form] = Form.useForm()
	const [form2] = Form.useForm()
	const {t} = useTranslation(['resources', 'translation'])
	const [userType, setUserType] = useState(10)
	const [loading, setLoading] = useState(false)
	const [checked, setChecked] = useState(false)
	const [isConfirmedByPhone, setIsConfirmedByPhone] = useState(false)
	const [state, setState] = useState<ModalState>({open: false, userId: null})
	const {clientTypes} = useSelector((state: AppStateType) => state.userReducer)
	const validateMessages = {
		required: t('validation:RequiredField')
	}

	useEffect(() => {
		if (!clientTypes || !clientTypes.length)
			dispatch(getUserTypes())
	}, [clientTypes])

	const userTypeChange = (value: number) => {
		form.resetFields([
			'postIndex', 'oblast', 'raion',	'city',	'address', 'street', 'building', 'apartment',
			'numberDocRB', 'confirmNumberDocRB', 'numberForeignDoc', 'confirmNumberForeignDoc', 'dateDoc', 'organDoc'
		])
		setUserType(value)
	}

	const radioConfirmChange = (e: RadioChangeEvent) => {
		setIsConfirmedByPhone(e.target.value)
	}

	const checkUser = (event: React.ChangeEvent<HTMLInputElement>) => {
		let value = event.target.value as string
		if(value.match(/^[a-zA-Z][a-zA-Z0-9-_@.]{5,20}$/)) {
			apiUser.checkUser(value)
				.then((res) => {})
				.catch(err => {setFormErrors(err, form)})
		}
	}

	const onFinish = (values: any) => {
		setLoading(true)
		let result = { ...values,
			phoneNumber: values.phoneNumber ? values.phoneNumber : null,
			contactPhoneNumber: values.contactPhoneNumber ? values.contactPhoneNumber : null,
			dateDoc: values.dateDoc ? values.dateDoc.format() : null
		}
		apiUser.register(result)
			.then((res) => {
				if(res.code == 200) {
					if(isConfirmedByPhone) {
						setState({open: true, userId: res.data})
					} else {
						form.resetFields()
						Modal.success({
							title: t('ConfirmEmail'),
							content: res.message,
						});
					}
				}
			})
			.catch(err => {setFormErrors(err, form)})
			.finally(() => setLoading(false))
	}

	const onFinish2 = (values: any) => {
		let result = { ...values, phoneNumber: form.getFieldValue('phoneNumber'), id: state.userId}
		setLoading(true)
		apiUser.verifyPhoneNumber(result)
			.then((res) => {
				if(res.code == 200) {
					setState({open: false, userId: null})
					window.location.href = `/`
				}
			})
			.catch(err => {setFormErrors(err, form2)})
			.finally(() => setLoading(false))
	}

	const getFormFieldsByUserType = () => {
		switch (userType){
			case 10 : //Юридическое лицо РБ
				return <Company form={form} isLegalEntityRB={true} />
			case 11 : //Гражданин РБ
				return (
					<Citizen form={form} user={props.location.state} />
				)
			case 20 : //Иностранная организация
				return <Company form={form} isLegalEntityRB={false} />
			case 21 : //Иностранный гражданин
			case 30 : //Лицо без гражданства
				return <Foreign form={form} userType={userType} />
			default :
				return <></>
		}
	}

	const formItemLayout = {
		labelCol: {
			xs: { span: 24 },
			sm: { span: 10 },
			xxl: {span: 10 }
		},
		wrapperCol: {
			xs: { span: 24 },
			sm: { span: 14 },
			xxl: {span: 14 }
		},
	};

	return (
		<>
			<h2 className="register-header">
				{t('Registration')}
			</h2>
			<Row
				align="middle"
				justify="center"
			>
				<Form
					className="register-form"
					{...formItemLayout}
					form={form}
					validateMessages={validateMessages}
					onFinish={onFinish}
					colon={false}
					initialValues={{
						'clientTypeCode': userType,
						'isConfirmedByPhone': isConfirmedByPhone
					}}
				>
					<Form.Item
						className="new-block"
						name="clientTypeCode"
						label={t('AppUserClientType')}
						rules={[
							{
								required: true
							}
						]}
					>
						<CustomSelect
							//value={userType}
							onChange={userTypeChange}
						>
							{clientTypes &&
							clientTypes.map((e) => {
								return (<Option key={e.id} value={e.code}>{e.name}</Option>)
							})}
						</CustomSelect>
					</Form.Item>
					<Form.Item
						name="isConfirmedByPhone"
						label={t('RegisterViewModelConfirm')}
					>
						<Radio.Group onChange={radioConfirmChange}>
							<Radio value={true}>
								{t('AppUserPhoneNumber')}
							</Radio>
							<Radio  value={false}>
								{t('Email')}
							</Radio>
						</Radio.Group>
					</Form.Item>
					<Form.Item
						hasFeedback
						label={t('ApplicationUserName')}
						name="userName"
						rules={[
							{
								required : true,
								message : t('validation:RequiredField')
							},
							{
								pattern  : /^[a-zA-Z][a-zA-Z0-9-_@.]{5,20}$/,
								message  : t('validation:ValidateUserName'),
							}
						]}
					>
						<CustomInput
							autoComplete="off"
							maxLength={30}
							onBlur={checkUser}
							placeholder={t('ApplicationUserName')}
						/>
					</Form.Item>
					<Form.Item
						hasFeedback
						label={t('RegisterViewModelPassword')}
						name="password"
						normalize={(value) => (value ? value.trim() : value)}
						rules={[
							{
								required : true,
								message : t('validation:RequiredField')
							},
							{
								pattern  : /(?=^.{8,20}$)(?=.*\d)(?=.*\W+)(?![.\n])(?=.*[A-Z])(?=.*[a-z])[^А-Яа-я].*$/,
								message  : t('validation:ValidatePassword')
							}
						]}
					>
						<CustomInput
							autoComplete="new-password"
							maxLength={30}
							type="password"
						/>
					</Form.Item>
					<Form.Item
						hasFeedback
						dependencies={["password"]}
						label={t('RegisterViewModelConfirmPassword')}
						name="confirmPassword"
						normalize={(value) => (value ? value.trim() : value)}
						rules={[
							{
								required : true,
								message : t('validation:RequiredField')
							},
							({ getFieldValue }) => ({
								validator(_, value){
									if (!value || getFieldValue("password") === value)
										return Promise.resolve()
									return Promise.reject(t('validation:ViewModelConfirmPassword'))
								}
							})
						]}
					>
						<CustomInput
							autoComplete="new-password"
							maxLength={30}
							type="password"
						/>
					</Form.Item>
					<Form.Item
						hasFeedback
						className="new-block"
						label={t('AppUserPhoneNumber')}
						name="phoneNumber"
						rules={[
							{
								required: isConfirmedByPhone,
								message : t('validation:RequiredField')
							},
							({ getFieldValue }) => ({
								validator(_, value){
									let code = (getFieldValue("clientTypeCode"))
									let regex=/^\d{1,3}\d{2,5}\d{5,7}$/
									if(code === 10 || code === 11)
										regex=/^375(29|25|44|33)\d{7}$/
									if (!value || regex.test(value))
										return Promise.resolve()
									return Promise.reject(t('validation:ValidationMobileNumber'))
								}
							})
						]}
					>
						<CustomInput
							autoComplete="off"
							maxLength={100}
							placeholder="375290000000"
						/>
					</Form.Item>
					<Form.Item
						hasFeedback
						label={t('AppUserContactPhone')}
						name="contactPhoneNumber"
						rules={[
							{
								pattern : /^\d{1,3}\d{2,5}\d{5,7}$/,
								message : t('validation:ValidationPhoneNumber')
							}
						]}
					>
						<CustomInput
							autoComplete="off"
							maxLength={100}
							placeholder="375170000000"
						/>
					</Form.Item>
					<Form.Item
						hasFeedback
						label="E-mail"
						name="email"
						rules={[
							{
								type : "email",
								required : !isConfirmedByPhone
							}
						]}
					>
						<CustomInput
							autoComplete="off"
							maxLength={100}
							placeholder="Email"
						/>
					</Form.Item>
					{ getFormFieldsByUserType() }
					<Form.Item
						className="license new-block agreement"
						rules={[{ required : true }]}
					>
						<Checkbox
							onChange={(e) => {
								setChecked(e.target.checked)
							}}
						>
							{' ' + t('IAcceptConditions') + ' '}
							<a href={`/Content/Docs/Пользовательское соглашение.pdf`} target="_blank">
								{t('UserAgreement')}
							</a>
						</Checkbox>
					</Form.Item>
					<Form.Item
						className="register-tail"
					>
						<Button
							disabled={!checked}
							htmlType="submit"
							loading={loading}
							size='large'
							type="primary"
						>
							{t('Register')}
						</Button>
					</Form.Item>
				</Form>
			</Row>
			<Modal
				title={t('VerifyPhoneNumber')}
				visible={state.open}
				centered
				onCancel={() => setState({open: false, userId: null})}
				footer={[]}
			>
				<Form
					form={form2}
					name='verifyPhoneNumber'
					onFinish={onFinish2}
				>
					<p>{t('EnterVerificationCode')}</p>
					<Form.Item
						label={t('VerifyCodeViewModelCode')}
						name="code"
						rules={[
							{
								required : true,
								message : t('validation:RequiredField')
							}
						]}
					>
						<Input />
					</Form.Item>
					<Button
						htmlType="submit"
						color="primary"
						loading={loading}
						style={{display: 'block', marginLeft: 'auto'}}
					>
						{t('SendButtonValue')}
					</Button>
				</Form>
			</Modal>
		</>
	)
}

export default Register